<script>

    import Time from "svelte-time";

    export let comment;
    export let model_root;
    export let reloadComments;

    const deleteComment = async () => {
        if (!confirm(`Soll dieser Kommentar wirklich entfernt werden? Dies kann nicht rückgängig gemacht werden!`)) {
            return;
        }
        const response = await fetch(model_root + 'admin/contents/comments/delete_comment.php?id=' + comment.comment_id, {
            method: "GET"
        }).then(response => response.text());
        if (response === "success") {
            reloadComments();
        } else {
            console.error("Ein Fehler ist aufgetreten: " + response);
        }
    }

</script>

{#if comment.author === undefined}
    <h6 class="mb-0">Gelöschter Kommentar</h6>
    <p class="mb-2 mt-1"><i>Dieser Kommentar wurde gelöscht.</i></p>
{:else}
    <h6 class="mb-0">
        {@html comment.author}
        {#if comment.official == 1}
            <span class="badge bg-success text-white border-0 px-1 ms-1">Admin</span>
        {/if}
        <button class="btn-sm btn-primary float-end" on:click={deleteComment}><i class="fas fa-trash-alt"></i></button>
    </h6>
    <small class="text-muted"><Time timestamp="{comment.timestamp}" format="DD.MM.YYYY HH:mm" /></small>
    <p class="mb-2 mt-1">{@html comment.content}</p>
{/if}
